<h2 mat-dialog-title class="rpf__title" autoTranslate>Novo previsto</h2>

<mat-dialog-content class="rpf__content">
    <section class="rpf__section">
        <span class="rpf__label" autoTranslate>Médicos reguladores</span>
        <mat-form-field class="rpf__field w-full" [subscriptSizing]="'dynamic'">
            <mat-select [(ngModel)]="userIds" multiple>
                <mat-option *ngFor="let u of data.regulators" [value]="u.user_id">{{ u.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </section>

    <section class="rpf__section">
        <span class="rpf__label" autoTranslate>Empresas</span>
        <div class="rpf__companies">
            <label class="rpf__company rpf__company--all">
                <mat-checkbox
                    [checked]="allSelected"
                    [indeterminate]="someSelected"
                    (change)="toggleAll($event.checked)"
                ></mat-checkbox>
                <span autoTranslate>Todas</span>
            </label>
            <label class="rpf__company" *ngFor="let c of companyOptions">
                <mat-checkbox [(ngModel)]="c.selected" [ngModelOptions]="{ standalone: true }"></mat-checkbox>
                <span>{{ c.name }}</span>
            </label>
        </div>
    </section>

    <section class="rpf__section">
        <span class="rpf__label" autoTranslate>Início</span>
        <div class="rpf__datetime">
            <mat-form-field class="rpf__field" [subscriptSizing]="'dynamic'">
                <mat-label autoTranslate>Data</mat-label>
                <input matInput type="date" [(ngModel)]="dateStart" />
            </mat-form-field>
            <mat-form-field class="rpf__field" [subscriptSizing]="'dynamic'">
                <mat-label autoTranslate>Hora</mat-label>
                <input matInput type="time" [(ngModel)]="timeStart" />
            </mat-form-field>
        </div>
    </section>

    <section class="rpf__section">
        <span class="rpf__label" autoTranslate>Fim</span>
        <div class="rpf__datetime">
            <mat-form-field class="rpf__field" [subscriptSizing]="'dynamic'">
                <mat-label autoTranslate>Data</mat-label>
                <input matInput type="date" [(ngModel)]="dateEnd" [min]="dateStart" />
            </mat-form-field>
            <mat-form-field class="rpf__field" [subscriptSizing]="'dynamic'">
                <mat-label autoTranslate>Hora</mat-label>
                <input matInput type="time" [(ngModel)]="timeEnd" />
            </mat-form-field>
        </div>
    </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="rpf__actions">
    <button mat-stroked-button type="button" (click)="cancel()">
        <span autoTranslate>Cancelar</span>
    </button>
    <button mat-flat-button color="primary" type="button" [disabled]="!canSave" (click)="submit()">
        <span autoTranslate>Salvar</span>
    </button>
</mat-dialog-actions>
